import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsWalkNormalSmall = React.forwardRef(
  ({ color = "currentColor", size = 24, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M9.7 4a5 5 0 012.94.956l4.368 3.177 4.595 2.12A4.127 4.127 0 0124 14.002v.018c0 .314.002 1.416-.898 2.398-.922 1.005-2.567 1.656-5.333 1.584H2.414a2.414 2.414 0 01-1.707-4.122l.086-.086a.707.707 0 00.207-.5V6.547C1 5.693 1.693 5 2.547 5c.555 0 1.088.22 1.48.613L5.414 7h1.699L6.55 5.316A1 1 0 017.5 4zM2.393 15c-.058.072-.12.141-.187.207l-.086.086a.414.414 0 00.293.707H17.81c2.489.068 3.449-.531 3.819-.935.372-.406.372-.847.372-1.062v-.002c0-.35-.086-.687-.242-.985-.4.059-.638.278-1.05.691l-.027.026C20.17 14.243 19.415 15 18 15zm17.555-3.307l-3.092-1.426-1.08 1.62-1.664-1.11 1.022-1.533-.738-.537-1.12 1.68-1.664-1.11 1.165-1.747-1.314-.956A3 3 0 009.699 6h-.812l1 3H4.587L3 7.414V13h15c.56 0 .803-.218 1.293-.707l.026-.026c.175-.176.38-.38.63-.573z"
        fill=""
      />
    </svg>
  )
);
SvgSportsWalkNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsWalkNormalSmall;
